import { render } from "./AddEditWorkout.vue?vue&type=template&id=15a19ba6"
import script from "./AddEditWorkout.vue?vue&type=script&lang=js"
export * from "./AddEditWorkout.vue?vue&type=script&lang=js"

import "./AddEditWorkout.vue?vue&type=style&index=0&id=15a19ba6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__